/* Retour Stripe — succès. Poll le statut avant de confirmer (jamais sur le seul redirect). */
import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, AlertTriangle } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | pending_timeout | error
  const [planApplied, setPlanApplied] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      try {
        const r = await axios.get(`${API}/api/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setPlanApplied(r.data.plan_applied || null); setState("paid"); return; }
        if (["failed", "expired"].includes(r.data.payment_status)) { setState("error"); return; }
      } catch (e) { /* retry */ }
      if (attempts.current >= 15) { setState("pending_timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0b0d12] text-zinc-100 flex items-center justify-center p-6" data-testid="payment-success-page">
      <div className="max-w-md w-full text-center space-y-4">
        {state === "checking" && (
          <>
            <Loader2 className="w-10 h-10 animate-spin text-[#378ADD] mx-auto" />
            <h1 className="text-xl font-semibold">Vérification du paiement…</h1>
            <p className="text-sm text-zinc-400">Ne fermez pas cette page.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-[#1D9E75] mx-auto" />
            <h1 className="text-xl font-semibold" data-testid="payment-confirmed">Paiement confirmé — merci !</h1>
            <p className="text-sm text-zinc-400">
              {planApplied
                ? <>Le plan <span className="text-[#1D9E75] font-semibold capitalize">{planApplied}</span> est maintenant actif : les modules correspondants sont débloqués.</>
                : "Votre abonnement Noam est actif. Un reçu vous a été envoyé par Stripe."}
            </p>
            <Link to="/app" className="btn-primary inline-flex text-sm mt-2">Retour à l'application</Link>
          </>
        )}
        {state === "pending_timeout" && (
          <>
            <Loader2 className="w-10 h-10 text-[#EF9F27] mx-auto" />
            <h1 className="text-xl font-semibold">Paiement en cours de traitement</h1>
            <p className="text-sm text-zinc-400">La confirmation prend plus de temps que prévu. Vous recevrez un email dès validation.</p>
            <Link to="/app" className="btn-secondary inline-flex text-sm mt-2">Retour à l'application</Link>
          </>
        )}
        {state === "error" && (
          <>
            <AlertTriangle className="w-12 h-12 text-[#E24B4A] mx-auto" />
            <h1 className="text-xl font-semibold">Paiement non confirmé</h1>
            <p className="text-sm text-zinc-400">La session est invalide ou le paiement a échoué. Aucun montant n'a été prélevé.</p>
            <Link to="/app/facturation" className="btn-secondary inline-flex text-sm mt-2">Réessayer</Link>
          </>
        )}
      </div>
    </div>
  );
}
